import axios from "axios";
import { ILoggingAPIBody, ILoggingAPIsuccessResposnse } from "../types/LoggingTypes";
import { getCookies } from "../../Helpers/functions";

export const LoggingAPICall = async (
    body: ILoggingAPIBody
): Promise<ILoggingAPIsuccessResposnse> => {
    return axios.post(`${process.env.REACT_APP_NEXT_PUBLIC_LOGGING_URL_CLIENT}` , body , {
        
        headers: {
            'Authorization': 'Bearer ' + process.env.REACT_APP_LOGGED_OFF_AUTH_TOKEN,
            'source': getCookies().source,
            'accept-language': getCookies().NEXT_LOCALE,
            'session-id': getCookies().userInfo.id,
            'country': getCookies().ecountry,
            'x-tracking-uuid': getCookies().device_uuid,
            'Content-Type': 'application/json',
            'enforce-language': getCookies().NEXT_LOCALE
        }
    })
};
